/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTaxCategoryRequest } from '../../models/create-tax-category-request';
import { TaxCategory } from '../../models/tax-category';

export interface TaxCategoriesTaxCategoryIdPut$Params {
  'Active-Tenant-Identifier': string;
  taxCategoryId: string;
      body: CreateTaxCategoryRequest
}

export function taxCategoriesTaxCategoryIdPut(http: HttpClient, rootUrl: string, params: TaxCategoriesTaxCategoryIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategory>> {
  const rb = new RequestBuilder(rootUrl, taxCategoriesTaxCategoryIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('taxCategoryId', params.taxCategoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TaxCategory>;
    })
  );
}

taxCategoriesTaxCategoryIdPut.PATH = '/tax-categories/{taxCategoryId}';
